<template>
  <el-popover placement="top"  v-model="visible">
    <p v-if="message">{{message}}</p>
    <div class="buttons">
      <el-button size="mini" type="text" @click="onChange(item.value)" v-for="item in states" :key="item.value">
          {{item.name}}
      </el-button>
    </div>
    <el-button slot="reference" :size="size" :type="type">
      <slot></slot>
    </el-button>
  </el-popover>
</template>

<script>
export default {
    props: {
        size: {
            type: String
        },
        type: {
            type: String
        },
        states: {
            type: Array
        },
        message: {
            type: String,
            default: ''
        }
    },
    data: function () {
        return {
            visible: false
        };
    },
    methods: {
        onChange(state) {
            this.visible = false;
            this.$emit('change', state);
        }
    }
};
</script>

<style scoped>
.buttons{
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
</style>